exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal_body {\n  position: relative; }\n  .modal_body .submit_buttons {\n    position: absolute;\n    left: 30%;\n    margin-top: 15px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/ui/timeoutCountdown/timeoutCountdown.scss
// module id = 948
// module chunks = 1